import Option from './option';

class GeocodeGoogleOption extends Option {
  details;

  constructor(description, logo, details) {
    super(description, logo);
    this.details = details;
  }

  async fetchDetails() {
    return this.details;
  }
}

export default GeocodeGoogleOption;
